import { render, staticRenderFns } from "./ViberTemplate.vue?vue&type=template&id=43b7765c&"
import script from "./ViberTemplate.vue?vue&type=script&lang=ts&"
export * from "./ViberTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports